<template>
  <div class="vcl-slider-toggle">
    <label v-if="$slots.label && labelAlignment === 'left'" :for="_uid + 'VpSliderToggle'" class="vcl-slider__label" :class="{ 'disabled': disabled }" :style="labelStyles">
      <slot name="label" />
    </label>
    <div ref="slider" class="vcl-slider-toggle__container" :style="sliderStyle" :tabindex="tabIndex" @click="toggleSlider" @keydown="handleKeydown">
      <div :id="id+'Slider'" class="sliderToggleBase" :style="baseStyle" />
      <vp-icon :id="id+'SliderCheck'" icon="slider_toggle_check" class="sliderCheck" :style="checkStyle" />
      <vp-icon :id="id+'SliderButton'" icon="slider_toggle_button" class="sliderButton" :style="toggleButtonStyle" />
      <input :id="_uid+'VpSliderToggle'" ref="sliderCheckbox" class="sliderToggleCheckbox" type="checkbox" :selected="isSelected">
    </div>
    <VpTooltip :body="tooltipText" :placement="tooltipOpts.placement" :disabled="tooltipOpts.disabled" :target="[$refs, 'slider']" />
    <label v-if="$slots.label && labelAlignment === 'right'" :for="_uid + 'VpSliderToggle'" class="vcl-slider__label" :class="{ 'disabled': disabled }" :style="labelStyles">
      <slot name="label" />
    </label>
  </div>
</template>
<script>
export default {
  name: 'VpSliderToggle',
  props: {
    id: {
      type: String,
      default: '',
    },
    value: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    tooltip: {
      type: Object,
      default: null,
    },
    labelAlignment: {
      type: String,
      default: 'left',
    },
    styles: {
      type: Object,
      default: null,
    },
  },
  emits: ['input'],
  data() {
    return {
      internalValue: 0,
    };
  },
  computed: {
    tooltipOpts() {
      const { tooltip } = this;
      return {
        placement: (tooltip && 'placement' in tooltip) ? tooltip.placement : 'right',
        disabled: (tooltip && 'disabled' in tooltip) ? tooltip.disabled : Boolean(!tooltip),
        text: (tooltip && 'text' in tooltip) ? tooltip.text : [this.$i18n.t('off'), this.$i18n.t('on')],
      };
    },
    baseStyle() {
      const style = {
        'box-shadow': '0px 1px 2px 0px rgba(0, 0, 0, 0.1) inset',
        'border-radius': '16px',
        'background-color': '#A7CCE1',
        cursor: 'pointer',
        height: '28px',
        position: 'absolute',
        width: '50px',
      };
      if (this.internalValue && this.styles && this.styles.onColor !== '') {
        style['background-color'] = this.styles.onColor;
      }
      if (this.internalValue === 0) {
        if (this.styles && this.styles.offColor !== '') {
          style['background-color'] = this.styles.offColor;
        } else {
          style['background-color'] = '#DBDBDB';
        }
      }
      if (this.disabled) {
        style.cursor = 'not-allowed';
        style.opacity = '30%';
      }
      return style;
    },
    checkStyle() {
      const style = {
        display: 'none',
        height: '8px',
        position: 'absolute',
        width: '10px',
      };
      if (this.internalValue === 1) {
        style.color = '#fff';
        style.display = 'block';
        style['margin-left'] = '8px';
        style['margin-top'] = '10px';
      }
      return style;
    },
    labelStyles() {
      const style = {
        cursor: 'pointer',
        display: 'inline-block',
        'font-size': '16px',
        'margin-top': '-2px',
        'user-select': 'none',
        'vertical-align': 'middle',
      };
      return style;
    },
    isSelected() {
      if (this.internalValue === 0) {
        return false;
      } return true;
    },
    sliderStyle() {
      const style = {
        display: 'inline-block',
        height: '30px',
        'margin-left': '12px',
        'vertical-align': 'middle',
        width: '52px',
      };
      if (this.labelAlignment === 'right') {
        style['margin-left'] = '0px';
        style['margin-right'] = '12px';
      }
      return style;
    },
    tabIndex() {
      if (this.disabled) {
        return -1;
      } return 0;
    },
    toggleButtonStyle() {
      const style = {
        color: '#fff',
        cursor: 'pointer',
        height: '28px',
        position: 'absolute',
        width: '28px',
      };
      if (this.internalValue === 1) {
        style['margin-left'] = '20px';
      }
      if (this.disabled) {
        style.cursor = 'not-allowed';
      }
      return style;
    },
    tooltipText() {
      return this.tooltipOpts.text[this.internalValue];
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.internalValue = newValue;
      }
    },
  },
  created() {
    this.internalValue = this.value;
  },
  methods: {
    toggleSlider: function toggleSlider() {
      if (this.disabled) {
        return;
      }
      const checkbox = this.$refs.sliderCheckbox;
      if (this.internalValue === 1) {
        this.internalValue = 0;
        checkbox.checked = false;
      } else {
        this.internalValue = 1;
        checkbox.checked = true;
      }
      this.$emit('input', this.internalValue);
    },
    handleKeydown(evt) {
      if ((evt.key === 'Space') || (evt.key === ' ')) {
        this.toggleSlider();
        evt.stopPropagation();
        evt.preventDefault();
      }
    }
  },
};
</script>
<style lang="scss">
input.sliderToggleCheckbox {
  display:none;
}
.vcl-slider-toggle {
  display: flex;
  flex: 1 1 50%;
  align-items: center;
  position: relative;
  &__container {
    position: relative;
  }
  .sliderButton {
    left: 0;
  }
}
</style>
